import classNames from 'classnames';
import { format as dateFormat } from 'date-fns';
import { generatePath } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Flex } from 'yoso';
import { Don } from '~/components/Don/Don';
import { DonHistory } from '~/components/Don/History/DonHistory.hooks';
import { T } from '~/components/I18n';
import { Link } from '~/components/Route/Link';
import { format } from '~/components/Util/number';
import styles from './DonHistoryListItem.module.scss';

const historyItemFormat = (value?: number) =>
  format(value, {
    sign: true,
  });

export const DonHistoryListItem = ({ createdAt, reasonType, reasonDetail, amount }: DonHistory) => {
  const isPositive = amount > 0;
  const { search } = useLocation();

  return (
    <Flex container className={styles.root} justifyContent="space-between">
      <div className={styles.body}>
        <p className={styles.reason}>
          <T name={reasonType} options={reasonDetail} />
        </p>
        <div className={styles.date}>{dateFormat(createdAt, 'PP p')}</div>
      </div>
      <div className={styles.aside}>
        <div className={classNames(styles.don, { [styles.blue]: isPositive })}>
          <Link
            to={
              reasonDetail?.rewardHistoryId && {
                pathname: generatePath('/membership/don/history/:id', {
                  id: reasonDetail.rewardHistoryId,
                }),
                search,
              }
            }
            replace
            className={styles.button}>
            <Don value={amount} format={historyItemFormat} /> DON
          </Link>
        </div>
      </div>
    </Flex>
  );
};
